// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"10":"c561c2a7","162":"aed2c38b","373":"2973aea2"}[chunkId] + ".js";
};